import useAuthUser from '../hooks/useAuthUser';
import { getAppPublicPathUrl } from '../utils/tenant';
import ModuleAccessGate from './ModuleAccessGate.tsx';

function ProtectedRoute({ children, user }) {
  const effectiveUser = useAuthUser(user || null);
  // Use user presence (id or username); tenant auth_user from URL has username only, no id.
  const hasUser = effectiveUser && (effectiveUser.id != null || effectiveUser.username);
  if (!hasUser) {
    if (typeof window !== 'undefined') {
      window.location.replace(getAppPublicPathUrl('/signin'));
    }
    return null;
  }

  return <ModuleAccessGate>{children}</ModuleAccessGate>;
}

export default ProtectedRoute;